import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Config from 'config';
import mediator, { ACTIONS } from 'mediator';
let config;
import { ERROR_CONSTANTS } from '../constants';
import metrics from '../lib/common/metrics';
import { toCurrency } from '../lib/common/displayHelpers';
import calculateTotal from '../lib/pricing/calculateTotal';

import { IconChevronUp, IconChevronDown } from './Icons';
import LineItem from './LineItem';

class Basket extends Component {
  constructor(props) {
    super(props);
    config = new Config().getConfig();

    this.state = {
      // Default to closed on small screens, open on large screens.
      isOpen:
        window.matchMedia && window.matchMedia('(min-width: 40em)').matches
          ? true
          : false
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.renderBasicNoticeMessage = this.renderBasicNoticeMessage.bind(this);
    this.updateCartCount = this.updateCartCount.bind(this);
  }

  componentWillMount() {
    mediator.subscribe(ACTIONS.UPDATE_CART_DETAILS, this.updateCartCount);
  }

  componentWillUnmount() {
    mediator.unsubscribe(ACTIONS.UPDATE_CART_DETAILS, this.updateCartCount);
  }

  updateCartCount(cart) {
    cart.count = this.props.lineItems.length;
  }

  handleToggle() {
    this.setState(
      prevState => {
        return {
          isOpen: !prevState.isOpen
        };
      },
      () => {
        metrics.action('Toggle cart', this.state.isOpen ? 'open' : 'close');
      }
    );
  }

  renderBasicNoticeMessage() {
    const shouldRenderMessage =
      this.props.noticeMessage &&
      Object.keys(ERROR_CONSTANTS).indexOf(this.props.noticeMessage) == -1;

    if (shouldRenderMessage) {
      return (
        <div
          className="syos-basket__message"
          dangerouslySetInnerHTML={{ __html: this.props.noticeMessage }}
        />
      );
    } else {
      return null;
    }
  }

  renderPriceTypeMessage() {
    let priceTypeMessages = [];
    this.props.lineItems.map(item => {
      for (let priceTypeMessage of config.priceTypeMessages) {
        for (let priceTypesToCheck of priceTypeMessage.priceTypeIds) {
          if (
            priceTypesToCheck == item.priceData.price_type &&
            !priceTypeMessages.includes(priceTypeMessage.text)
          ) {
            priceTypeMessages.push(priceTypeMessage.text);
          }
        }
      }

      for (let zoneMessage of config.zoneMessages) {
        for (let zoneToCheck of zoneMessage.zoneIds) {
          if (
            zoneToCheck == item.priceData.zone_no &&
            !priceTypeMessages.includes(zoneMessage.text)
          ) {
            priceTypeMessages.push(zoneMessage.text);
          }
        }
      }
    });

    if (priceTypeMessages.length > 0) {
      return (
        <ul className="syos-basket__price-messages">
          {priceTypeMessages.map(priceMessage => {
            return (
              <li className="syos-basket__price-message" key={priceMessage}>
                {priceMessage}
              </li>
            );
          })}
        </ul>
      );
    } else {
      return null;
    }
  }

  render() {
    const totalToDisplay = toCurrency(
      calculateTotal(this.props.lineItems.map(x => x.priceData.price))
    );

    return (
      <div
        className={classnames('syos-basket', {
          'syos-basket--closed': !this.state.isOpen
        })}
      >
        {this.renderBasicNoticeMessage()}
        <div className="syos-basket__inner">
          <div className="syos-basket__header">
            <div className="syos-basket__details">
              <button
                className="syos-basket__toggle u-syos-button-reset"
                onClick={this.handleToggle}
              >
                {this.state.isOpen ? <IconChevronDown /> : <IconChevronUp />}
                <span className="syos-basket__total">
                  <span className="syos-basket__total-label">
                    {`${config.basket.totalLabel}: `}
                  </span>
                  <span className="syos-basket__total-value">
                    {totalToDisplay}
                  </span>
                </span>
              </button>
            </div>
            <div className="syos-basket__actions">
              <button
                className="syos-button"
                onClick={this.props.handleSubmit}
                disabled={this.props.isProcessing}
              >
                {this.props.buttonLabel}
              </button>
            </div>
          </div>
          <div className="syos-basket__contents">
            {this.renderPriceTypeMessage()}
            <div className="syos-basket__selections">
              <ul className="syos-basket__lineItems">
                {this.props.lineItems.map(item => {
                  return (
                    <li key={item.seatData.seat_no}>
                      <LineItem
                        mode={this.props.mode}
                        lineItems={this.props.lineItems}
                        lineItem={item}
                        prices={this.props.prices}
                        additionalPrices={this.props.additionalPrices}
                        priceTypes={this.props.priceTypes}
                        additionalPriceTypes={this.props.additionalPriceTypes}
                        priceTypeOptions={this.props.priceTypeOptions}
                        onClickRemoval={() => this.props.handleRemoval(item)}
                        onClickReselect={() =>
                          this.props.handleReselection(item)
                        }
                        onChangeUpdatePrice={this.props.handlePriceTypeChange}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
            {config.basket.extraMessages.length ? (
              <div className="syos-basket__extra u-syos-note">
                {config.basket.extraMessages.map((msg, idx) => {
                  return <p key={idx}>{msg}</p>;
                })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

Basket.propTypes = {
  mode: PropTypes.string,
  lineItems: PropTypes.array,
  isProcessing: PropTypes.bool,
  prices: PropTypes.array,
  additionalPrices: PropTypes.array,
  priceTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  additionalPriceTypes: PropTypes.arrayOf(PropTypes.object),
  noticeMessage: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleRemoval: PropTypes.func.isRequired,
  handleReselection: PropTypes.func.isRequired,
  handlePriceTypeChange: PropTypes.func.isRequired,
  priceTypeOptions: PropTypes.object,
};

export default Basket;



// WEBPACK FOOTER //
// ./src/javascripts/components/Basket.js